module.exports = __webpack_public_path__ + "img/in-icon.4a84ef48.svg";